import { ModelInstance, ToBackHook, ToFrontHook, BaseModel } from './util';
import { VolleyballStatistic } from './volleyball-statistic';
import { GameTeamStatisticBase } from './game-team-statistic-base';

@ModelInstance({
  mappingFields: {
    team: 'team',
    competitor_team: 'competitorTeam',
  },
  relation: {
    team: VolleyballStatistic,
    competitorTeam: VolleyballStatistic,
  }
})
export class VolleyballGameTeamStatistic extends BaseModel implements GameTeamStatisticBase {
  team: VolleyballStatistic;
  competitorTeam: VolleyballStatistic;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
